<div class="banner" ></div>
<div class="contact-box-item">

    <div class="contact">
        <h2>Sales Concierge</h2>
        <div class="small">
            Ihr persönlicher Brother Sales Concierge berät Sie zu allen Themen rund um Ihre Kundenprojekte und das Brother Lösungsportfolio - kurze Anfrage genügt!
        </div>

        <button (click)="openModal()" class="btn btn-primary small font-bold strict-sized-button mt-auto">
            Sales Concierge
        </button>
        <router-outlet></router-outlet>
    </div>
</div>


